import { Project } from '../../index'

export function createProjectName(project: Project, _index: number) {
  return project.projectName ? project.projectName : `Проект`
}
